import React, { useState, useEffect } from 'react';
import Female from '../../images/benefit/female.png'
import Male from '../../images/benefit/male.png'
import { getToken } from '../../utils/tokenHelper';
import Star from '../../images/star.png'

import { Link } from 'react-router-dom'

const Benefit = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    
        useEffect(() => {
            // Check if the token exists in localStorage
            const token = getToken();
            if (token) {
                setIsLoggedIn(true);
            }
        }, []);

    return (
        <div className='w-full flex items-center justify-between bg-white flex-col gap-4 p-8 md:px-8 lg:px-16 lg:flex-row lg:gap-6 raleway-font'>
          <div className='w-full flex items-start gap-2 flex-col
          '>
            <p className='text-2xl text-[#069125] instrument-sans-semibold'>
            BENEFITS
            </p>

            <p className='text-2xl text-[#011205] instrument-sans-bold'>
            We make quality <br /> Healthcare Accessible
            </p>

            <p className='text-[#233126] lg:mt-1 instrument-sans-medium'>
            We believe that reliable health related information should be <br className='hidden lg:block'/> accessible to all without restrictions. 
            <br className='hidden lg:block'/> We offer reliable access to health services, via our web app,<br className='hidden lg:block'/> anywhere & anytime.
            </p>

            <div className='flex flex-col gap-2 lg:gap-3'>
                <div className='flex gap-1 items-center'>
                    <p className='text-white'>Customer centred approach</p>
                </div>
            </div>

            <div className="flex gap-4 instrument-sans-semibold">                                     
                {isLoggedIn ? (
                    <Link to='/triva' 
                     className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base'>
                        <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                        <span>Play to Win Now </span>
                    </Link>
                ) : (
                    <Link to='/login' 
                     className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base'>
                        <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                        <span>Play to Win Now </span>
                    </Link>
                )}
                        
                {isLoggedIn ? (
                    <Link to='/health'
                    className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base' >
                        Ask AI Doctor
                    </Link>
                ) : (
                    <Link to='/login'
                    className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base' >
                        Get Started
                    </Link>
                )}
            </div>
          </div>

          <div className='lg:flex flex-col hidden w-full gap-3 mt-4 lg:mt-0'>
            <div className='flex w-full items-start gap-8'>
                <img src={Female} alt="" className='w-[277px] h-[604px]'/>
                
                <img src={Male} alt="" className='w-[277px] h-[604px]'/>
            </div>

           
          </div>
        </div>
    )
}

export default Benefit
